import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {concat} from 'rxjs';
import {DialogButtons, DialogData, FormValueTypeEnum} from "../../../common/interfaces/global-interfaces";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.dialogData = data;

    if (this.dialogData?.buttons?.length > 0){
      this.buttons = this.dialogData?.buttons;
    }

    if (this.dialogData?.title){
      this.title = this.dialogData?.title;
    }

    if (this.dialogData?.message){
      this.message = this.dialogData?.message;
    }

    if (this.dialogData?.placeholder){
      this.placeholder = this.dialogData?.placeholder;
    }

    if (this.dialogData?.isForm){
      this.buttons = [ { title: 'Cancel', value: false}, { title: 'Submit', value: true}];
    }
  }

  protected readonly FormValueTypeEnum = FormValueTypeEnum;

  dialogData: DialogData;
  title = 'Confirmation';
  message = 'are-you-sure';
  placeholder = 'are-you-sure';
  buttons: DialogButtons[] = [{ title: 'Yes', value: true}, { title: 'Cancel', value: false}];

  formGroup = new UntypedFormGroup({
    content: new UntypedFormControl()
  });

  protected readonly concat = concat;

  ngOnInit(): void {
  }
}
